import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'shared-prompt-dialog',
  templateUrl: './PromptDialog.component.html',
  styleUrl: './PromptDialog.component.scss',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
  ]
})
export class PromptDialogComponent {
  data = inject<{
    icon: string;
    label: string;
    message: string;
    title: string;
    value: string;
}>(MAT_DIALOG_DATA);

  public value = '';
}
